import { ReactNode, memo } from "react";
import { Box } from "@mui/material";
import { Text } from "$components";
import useJStyles from "$hooks/useJStyles";

export const TitleInfoContainer = memo(function TitleInfoContainer({
  icon,
  title,
}: {
  icon?: ReactNode;
  title: string;
}) {
  const { jclasses } = useJStyles();
  return (
    <Box className={jclasses.infoHeader}>
      {icon || null}
      <Text type="h3">{title}</Text>
    </Box>
  );
});
